import { create } from "zustand";

type TreesLastModifiedState = {
  lastModified: string | null;
  setLastModified: (lastModified: string | null) => void;
};

export const useTreesLastModified = create<TreesLastModifiedState>((set) => ({
  lastModified: null,
  setLastModified: (lastModified) => set({ lastModified }),
}));
